var FormView = /* @__PURE__ */ ((FormView2) => {
  FormView2["OneStep"] = "OneStep";
  FormView2["TwoStep"] = "TwoStep";
  return FormView2;
})(FormView || {});
var RegistrationFlow = /* @__PURE__ */ ((RegistrationFlow2) => {
  RegistrationFlow2["FullAccount"] = "FullAccount";
  RegistrationFlow2["LightAccount"] = "LightAccount";
  return RegistrationFlow2;
})(RegistrationFlow || {});
var ApplicationFlow = /* @__PURE__ */ ((ApplicationFlow2) => {
  ApplicationFlow2["FullAccount"] = "FullAccount";
  ApplicationFlow2["LightAccount"] = "LightAccount";
  return ApplicationFlow2;
})(ApplicationFlow || {});
export {
  ApplicationFlow,
  FormView,
  RegistrationFlow
};
//# sourceMappingURL=application-flow.js.map
